jQuery(document).ready(function () {
    if( jQuery('input#vat_number').length > 0){
        new WooToggleRequiredCvr();
    }

    const hidden_field = jQuery('.hide_billing_information');
    const button = jQuery('#showExtraDetails');
    const euVatNumber = jQuery('#woocommerce_eu_vat_number');
    var first_time = true;

    if(isEmpty(jQuery('#billing_first_name')) || isEmpty(jQuery('#billing_last_name')) || isEmpty(jQuery('#billing_email'))
        || isEmpty(jQuery('#billing_phone')) || isEmpty(jQuery('#billing_address_1')) || isEmpty(jQuery('#billing_postcode')) || isEmpty(jQuery('#billing_city'))) {
        change_state_for_field(hidden_field, button);
    }

    button.click( function () {
        change_state_for_field(hidden_field, button);
    });

    setTimeout(function () {
        if (hidden_field.css('display') == 'block') {
            euVatNumber.attr('style', 'display: block !important');
        } else {
            euVatNumber.attr('style', 'display: none !important');
        }
    }, 100);

    function change_state_for_field(hidden_field, button) {

        if(hidden_field.css('display') == 'block') {
            button.html('Vis faktureringsoplysninger');

        } else {
            button.html('Skjul faktureringsoplysninger');
        }

        hidden_field.slideToggle();

        setTimeout(function () {
            if (hidden_field.css('display') == 'block') {
                euVatNumber.attr('style', 'display: block !important');
            } else {
                euVatNumber.attr('style', 'display: none !important');
            }
        }, 450);

    }

    function isEmpty( el ){
        return !jQuery.trim(el.val())
    }
});

var WooToggleRequiredCvr = function(){
    // console.log('Init WooToggleRequiredCvr');
    var WTR = this;
    this.input = jQuery('input#vat_number');
    this.required_class = 'validate-required';

    this.payment_type_selector = 'input[type="radio"][name="payment_type"]';
    this.payment_type_inputs = jQuery(this.payment_type_selector);
    this.wrapper = this.input.closest('p.vat_number');

    this.initial_required = this.wrapper.hasClass(this.required_class);

    // console.log('Initial Req',this.initial_required);
    this.payment_type_inputs.on('change',function(){WTR.updateRequired.call(WTR);});

    this.getCurrentPaymentType = function(){
        return jQuery(this.payment_type_selector+':checked').val();
    };

    this.updateRequired = function(){
        if(this.getCurrentPaymentType() == '1'){
            // 1 = private
            this.setRequired(false);
        }else{
            this.setRequired(this.initial_required);
        }
    };

    this.setRequired = function(bool){
        // console.log('Set required',bool);
        if(bool){
            this.wrapper.addClass(this.required_class);
            this.wrapper.find('abbr.required').show();
        }else{
            this.wrapper.removeClass(this.required_class);
            this.wrapper.find('abbr.required').hide();
        }
        this.input.prop('required',bool);
    };

    this.updateRequired();
};


